import React, { useEffect, useMemo, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomPanel,
  InputNumeroInteiro,
  InputText,
  Loading,
  PageHeader,
} from '../../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../../assets/js/styles'
import { showMessageBox } from '../../../../../../store/actions/system.actions'
import EstoqueHttp from '../../../../../../services/api/https/estoque/Estoque.http'
import { getProdutos as getProdutosByCompany } from '../../../../../../services/api/https/registration/produto.http'
import { errorHandler } from '../../../../../../services/util/error.service'

function ItensManualExpedicao({ history, dispatch, selectedTp }) {
  const { selectedMovimentacao } = history.location.state || {}

  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const [produtos, setProdutos] = useState([])
  const [search, setSearch] = useState('')
  const [quantidades, setQuantidades] = useState({})
  const [identifier, setIdentifier] = useState('')
  useEffect(() => {
    async function init() {
      try {
        if (!selectedMovimentacao || !selectedMovimentacao.company_id) {
          throw new Error('Movimentação não encontrada. Volte e selecione uma movimentação válida.')
        }

        const res = await getProdutosByCompany(selectedMovimentacao.company_id)
        const list = Array.isArray(res) ? res : (res && res.produtos) || []

        setProdutos(Array.isArray(list) ? list.filter(p => p && p.actived) : [])
        setIsLoading(false)
      } catch (err) {
        setErrorMessage(errorHandler(err))
        setIsLoading(false)
      }
    }
    init()
  }, [selectedMovimentacao.company_id])

  useEffect(() => {
    if (errorMessage) dispatch(showMessageBox(null, errorMessage))
  }, [errorMessage, dispatch])

  const filtered = useMemo(() => {
    if (!search) return produtos
    const s = String(search).toLowerCase()
    return produtos.filter(
      p =>
        String(p.product_code).toLowerCase().includes(s) ||
        String(p.name).toLowerCase().includes(s),
    )
  }, [search, produtos])

  // --- Handlers ---
  function onChangeQuantidade(productId, value) {
    const v = Number(value) || 0
    setQuantidades(prev => ({ ...prev, [productId]: v }))
  }

  function onSalvar() {
    const items = Object.entries(quantidades)
      .map(([product_id, quantidade]) => ({
        product_id: Number(product_id),
        quantidade: Number(quantidade),
      }))
      .filter(i => i.product_id > 0 && i.quantidade > 0)

    if (!items.length) {
      return setErrorMessage('Informe quantidade em ao menos 1 produto.')
    }

    setShowConfirmModal(true)
  }

  async function onConfirmSalvar() {
    try {
      const items = Object.entries(quantidades)
        .map(([product_id, quantidade]) => ({
          product_id: Number(product_id),
          quantidade: Number(quantidade),
        }))
        .filter(i => i.product_id > 0 && i.quantidade > 0)

      setShowConfirmModal(false)
      setIsSaving(true)
      const { productsNotSaved } = await EstoqueHttp.importExpedicaoManual(
        selectedTp,
        selectedMovimentacao.id,
        items,
        identifier,
      )

      if (Array.isArray(productsNotSaved) && productsNotSaved.length) {
        setIsSaving(false)
        return setErrorMessage(
          'Alguns produtos não estão cadastrados para esta empresa: ' +
            productsNotSaved.map(p => `${p.code} - ${p.name}`).join(', '),
        )
      }

      // Sucesso
      dispatch(showMessageBox('Itens inseridos com sucesso.', null))
      setIsSaving(false)

      setQuantidades({})
      setIdentifier('')

      setTimeout(() => {
        history.goBack()
      }, 500)
    } catch (err) {
      setIsSaving(false)
      setErrorMessage(errorHandler(err))
    }
  }

  return (
    <div>
      <PageHeader>
        8.5 - Movimentacao de Estoque - Expedição - Importação de Itens Manuais
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <div className="p-grid">
          <div className="p-col-12">
            <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
              {isLoading ? (
                <Loading />
              ) : (
                <>
                  <div style={{ marginBottom: 16 }}>
                    <Btn onClick={onSalvar} isLoading={isSaving} disabled={isSaving}>
                      Salvar
                    </Btn>
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <CustomDataTableHeader value={search} onChange={setSearch} />
                  </div>

                  <DataTable
                    value={filtered}
                    paginator
                    rows={20}
                    emptyMessage="Nenhum produto encontrado."
                  >
                    <Column field="product_code" header="Código" bodyStyle={tableCellCentered()} />
                    <Column field="name" header="Produto" bodyStyle={tableCellCentered()} />
                    <Column
                      header="Quantidade"
                      body={row => (
                        <div style={{ width: 140 }}>
                          <InputNumeroInteiro
                            value={quantidades[row.id] || ''}
                            onChange={value => onChangeQuantidade(row.id, value)}
                            placeholder="0"
                          />
                        </div>
                      )}
                      bodyStyle={tableCellCentered()}
                      style={{ width: 160 }}
                    />
                  </DataTable>

                  <ConfirmDialog
                    title="Confirmar Importação"
                    isVisible={showConfirmModal}
                    content={
                      <div>
                        <p>
                          Ao salvar não será possível incluir novos itens na expedição. Digite o
                          identificador para prosseguir?
                        </p>
                        <div style={{ marginTop: '15px' }}>
                          <label
                            htmlFor="identifier"
                            style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}
                          >
                            Identificador:*
                          </label>
                          <InputText
                            id="identifier"
                            value={identifier}
                            onChange={setIdentifier}
                            placeholder="Digite o identificador"
                            style={{ width: '100%' }}
                          />
                        </div>
                      </div>
                    }
                    onOk={onConfirmSalvar}
                    onCancelar={() => setShowConfirmModal(false)}
                    disabled={isSaving || !identifier.trim()}
                  />
                </>
              )}
            </CustomPanel>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ItensManualExpedicao))
